


namespace TabAurous.Finance {
    export var companyids = [];
    export var finids = [];
    @Serenity.Decorators.registerClass()
    export class PaymentRegisterGrid extends Serenity.EntityGrid<PaymentRow, any> {
        protected getColumnsKey() { return 'Finance.Payment'; }
        protected getDialogType() { return PaymentDialog; }
        protected getIdProperty() { return PaymentRow.idProperty; }
        protected getInsertPermission() { return PaymentRow.insertPermission; }
        protected getLocalTextPrefix() { return PaymentRow.localTextPrefix; }
        protected getService() { return PaymentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        finids = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                        companyids = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });

            return filters;
        }
        //protected onViewSubmit() {

        //    if (!super.onViewSubmit.call(this))
        //        return false;
        //    var request = this.view.params;

        //    companyids = [];
        //    if (request.CompanyIds != undefined) {
        //        for (var i = 0; i < request.CompanyIds.length; i++) {
        //            companyids.push(request.CompanyIds[i]);
        //        }
        //    }
        //    finids = [];
        //    if (request.FinancialYearIds != undefined) {
        //        for (var i = 0; i < request.FinancialYearIds.length; i++) {
        //            finids.push(request.FinancialYearIds[i]);
        //        }
        //    }
        //    alert(finids.length.toString());

        //}
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);


            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Payment"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print Register',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
            //        Common.ReportHelper.execute({
            //            reportKey: 'Finance.PaymentRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
       
    }
}